import styles from './styles.module.css'

interface Props {
  userIconUrl: string | null | undefined
  displayName: string
  size?: 'xxs' | 'xs' | 'small' | 'medium' | 'large' | 'xlarge'
  className?: string
}

const SIZE_MAP = {
  xxs: { icon: '20px', emoji: '0.7rem' },
  xs: { icon: '24px', emoji: '0.8rem' },
  small: { icon: '32px', emoji: '1rem' },
  medium: { icon: '40px', emoji: '1.5rem' },
  large: { icon: '64px', emoji: '2rem' },
  xlarge: { icon: '96px', emoji: '3rem' },
}

export function UserIcon({ userIconUrl, displayName, size = 'medium', className }: Props) {
  const { icon, emoji } = SIZE_MAP[size]

  return (
    <>
      {userIconUrl ? (
        <img
          src={userIconUrl}
          alt={displayName}
          className={`${styles.userIcon} ${className || ''}`}
          style={{ width: icon, height: icon }}
        />
      ) : (
        <div
          className={`${styles.userIconPlaceholder} ${className || ''}`}
          style={{ width: icon, height: icon, fontSize: emoji }}
        >
          👤
        </div>
      )}
    </>
  )
}
